import { ConditionRegistryRuntimeKeyboard } from './ConditionRegistryRuntimeKeyboard';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryRuntimeInfo } from './ConditionRegistryRuntimeInfo';
export class ConditionRegistryRuntime extends ConditionRegistryCategory {
    label = 'Runtime';
    c_k = new ConditionRegistryRuntimeKeyboard(this);
    // readonly c_content = new ConditionRegistryRuntimeContent(this);
    c_i = new ConditionRegistryRuntimeInfo(this);
}
